import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.states';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { sparrowService } from 'app/services/sparrowService';
import { formatDate } from '@angular/common';
import { DialogNuevoClienteComponent } from 'app/utilerias/nuevo-cliente/dialog-nuevo-cliente.component';

@Component({
	selector: 'app-lista',
	templateUrl: './lista.component.html',
	styleUrls: ['./lista.component.scss']
})
export class ListaComponent implements OnInit {
	selectedProject: string = 'ACME Corp. Backend App';
	data: any = {
		columns: ['Nombre', 'Valor', 'Opciones'],
		rows: []
	};
	facturas: any;
	idPadre: number = 0;
	curCatalogo: any;
	catalogoForm: FormGroup;
	formModo: number = 1;
	tempEdit: any;
	registroCompleto = false;
	spinner: boolean = false;
	resumen: { FoliosDisponibles: number; FechaVencimiento: string; FacturadoMes: number; CanceladoMes: number; };
	operacion: any;
	UserData: any;
	RFC: any;
	FullName: any;
	Inicial: any;
	colorLetra: string;
	constructor(
		private readonly store: Store<AppState>,
		private baseService: BaseService,
		private coalService: CoalService,
		private router: Router,
		public dialog: MatDialog,
		private _formBuilder: FormBuilder,
        private sparroService : sparrowService
	) {

	}

	ngOnInit(): void {
		this.setOperacion();
	}

	setOperacion() {
		let parametros = {}

		// this.spinner = true;
		this.store.dispatch(MostrarSpinner());
		// this.spinner = true;

		this.coalService.postService(`operacion/PostGetOperacion`, parametros)
			.subscribe(
				(res: any) => {
					if (res.error) {

					} else if (res.excepcion) {

					} else {
						let respuesta = res.recordsets[0][0];

						respuesta['ajustes'] = res.recordsets[1][0];
						let data = {
							idOperacion: respuesta.idOperacion,
							idDireccion: respuesta.idDireccion,
							Direccion: respuesta.Direccion,
							RFC: respuesta.RFC,
							razonSocial: respuesta.razonSocial,
							nombreComercial: respuesta.nombreComercial,
							contactoEmail: respuesta.contactoEmail,
							contactoTelefono: respuesta.contactoTelefono,
							folioInicio: respuesta.folioInicio,
							fechaConfiguracion: respuesta.fechaConfiguracion,

							CP: respuesta.CP,
							calle: respuesta.calle,
							noExterior: respuesta.noExterior,
							noInterior: respuesta.noInterior,
							colonia: respuesta.colonia,

							estatus: {
								idOperacionEstatus: respuesta.idOperacionEstatus,
								nombre: respuesta.nombreEstatus,
								descripcion: respuesta.descripcionEstatus,
								fechaRegistro: respuesta.fechaRegistroHistorico,
								funcionesHabiles: respuesta.success 
							},

							tipoPersona: {
								idCatalogo: respuesta.idTipoPersona,
								nombre: respuesta.TipoPersona,
								valor: respuesta.TipoPersonaValue
							},

							giro: {
								idCatalogo: respuesta.idGiro,
								nombre: respuesta.Giro,
								valor: respuesta.GiroValue
							},

							regimenFiscal: {
								idCatalogo: respuesta.idRegimenFiscal,
								nombre: respuesta.RegimenFiscal,
								valor: respuesta.RegimenFiscalValue
							},

							tamanioEmpresa: {
								idCatalogo: respuesta.idTamanioEmpresa,
								nombre: respuesta.TamanioEmpresa,
								valor: respuesta.TamanioEmpresa
							},

							ajustes: {
								decimal: respuesta.ajustes?.decimal || 0,
								porcentaje: respuesta.ajustes?.porcentaje || 0,
								email_minFolios: respuesta.ajustes?.email_minFolios || 0,
								email_comprobantes: respuesta.ajustes?.email_comprobantes || 0
							}
						}
							//console.log(data);
						this.baseService.postOperacionData(data);

						if (respuesta.success) {
							this.registroCompleto = true;
							
							this.RFC = data.RFC;
							this.FullName = data.razonSocial;
							this.Inicial = data.razonSocial.substring(0,1);
							console.log(data.razonSocial.substring(1,1));

							const min = 0, max = 7;
							const colorRandom = Math.floor((Math.random() * (max - min + 1)) + min);
							const arrayColores = ["#2196f3", "#ffc107", "#28a745", "#dc3545", "#17a2b8", "#e83e8c", "#fd7e14", "#6f42c1"]
							this.colorLetra = arrayColores[colorRandom];

							this.getData();
							// this.spinner = false;
						} else {
							this.registroCompleto = false;
							this.router.navigateByUrl('/cuenta/perfil');
							// this.spinner = false;
							this.store.dispatch(OcultarSpinner());


						}
						// this.store.dispatch(AsignarOperacion( respuesta ))
					}
				}, (error: any) => {
					this.spinner = false;
				}
			)
	}

	getData() {
		let parametros;
		// this.store.dispatch(MostrarSpinner());
		// this.spinner = true;
		this.coalService.postService(`operacion/GetLastReportePDF`, parametros)
			.subscribe(
				(res: any) => {
					if (res.error) {

					} else if (res.excepcion) {

					} else {
						let respuesta = res.recordsets[0];
						this.resumen = res.recordsets[1][0]
						//console.log("respuesta", respuesta);

						this.facturas = {
							columns: ['Serie', 'Folio', 'Tipo de Factura',  'RFC', 'Nombre', 'Importe', 'Fecha', 'Descargar PDF', 'Descargar XML'],
							rows: respuesta
						};
						this.store.dispatch(OcultarSpinner())
						this.spinner = false;
						// this.snackBar.open(respuesta.msg, 'Ok', { duration: 10000 });
					}
					// this.spinner = false;
					this.store.dispatch(OcultarSpinner());
				}, (error: any) => {
					this.store.dispatch(OcultarSpinner());
					// this.spinner = false;
				}
			)
	}
	descargarxml(xmlvariable) {
        console.log(xmlvariable);
		var fileToExport = new Blob([xmlvariable.xml_format], { type: "text/xml" });
		var a = document.createElement("a");
		a.href = URL.createObjectURL(fileToExport);
		a.target = "_blank";
		a.download = xmlvariable.rfc + '-' + xmlvariable.nombre + ".xml"
		a.click();
	}
	descargarFactura(factura){
        console.log(factura.tipoFactura);
        switch(factura.tipoFactura){
            case "Factura" :
                this.facturaF(factura);
            break;
            case "Nota de Crédito" :
                this.facturaF(factura);
            break;
            case "Complemento de Pago":
                this.facturaC(factura);
            break;
        }

    }
    facturaC(factura){
        this.store.dispatch(MostrarSpinner());
        var body = {idfactura : factura.clave}
        this.coalService.postService(`catalogo/selReporteComplementos`, body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                let body = {
                    
                    logo : res.recordsets[8][0],
					emisor : {
                        nombre : res.recordsets[0][0].fullname,
                        rfc : res.recordsets[0][0].rfc,
                        direccion : res.recordsets[0][0].direccion,
                        lugar_emision : res.recordsets[0][0].LugarEmosion,
                    },
                    receptor : {
                        nombre : res.recordsets[1][0].nombreRazonSocial,
                        rfc : res.recordsets[1][0].rfc,
                        direccion : res.recordsets[1][0].direccion
                    },
                    productos : res.recordsets[3][0],
                    tproductos : res.recordsets[4][0].total,
                    pagos : res.recordsets[5],
                    DocsRel : res.recordsets[6],
                    footer : {
                        NoCertificado : res.recordsets[7][0].NoCertificado,
                        cadena_original : res.recordsets[7][0].SelloDgitalSAT,
                        sello_emisor : res.recordsets[7][0].Sello,
                        sello_sat : res.recordsets[7][0].SelloSAT,
                        version :res.recordsets[7][0].Version,
                        emisor_cert : res.recordsets[7][0].Certificado,
                        fecha_emit : res.recordsets[7][0].FechaTimbrado,
                        sat_cret : res.recordsets[7][0].NoCertificado,
                        pac : "Lorem",
                        qr : res.recordsets[7][0].SelloDgitalSAT
                    }
                };
                var name
                if(res.recordsets[7][0]?.uuid){
                    name = res.recordsets[7][0]?.uuid + " " + formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');
                }else{
                    name = formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');
                }
                this.sparroService.getReport("reportes/CallFeatureNew",body,name);
            };
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
        });
    }
    facturaF(factura){
        this.store.dispatch(MostrarSpinner());
        var factura_response;
        let data = {
            clave : factura.clave
        }
        this.coalService.postService("operacion/GetReporteFactura",data).subscribe(
        (response: any) => {
            factura_response = response.recordsets;
            var name = factura_response[0][0].uuid + " " + formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');;
            this.sparroService.getReport("reportes/SelPdf",factura_response,name);
        });
    }
	redirect(url: string) {
		//console.log(url);
		this.router.navigateByUrl(url);
		// this.router.navigate(['cuenta']);
	}
}
